import { Integer } from 'helpers';

export function LoadingState(loading = 0, message = '') {
	return { loading: Integer(loading), message };
}
